<template>
  <div id="app">
    <Layout class="app-wrapper">
      <Header id="app-header" class="app-header" v-show="$route.meta.showDaohang">
        <navigator></navigator>
      </Header>
      <Layout style="height:100%">
        <Sider hide-trigger id="app-sider" v-show="$route.meta.showLeftSideBar">
          <side-bar></side-bar>
        </Sider>
        <Content id="app-content">
           <transition :name="transitionName" v-if="isTV">
            <router-view v-if="isRouterAlive"></router-view>
          </transition>
          <router-view v-else-if="isRouterAlive"></router-view>

        </Content>
        <Sider hide-trigger id="app-filter" v-if="$route.meta.showFilter">
          <bk-filter></bk-filter>
        </Sider>
      </Layout>
      <!-- <Footer>Footer</Footer> -->
    </Layout>
    <spin size="large" fix v-show="spinShow"></spin>
  </div>
</template>
<script>
import navigator from "./components/navigator";
import sideBar from "./components/sidebar";
import bkFilter from "./components/filter/index";
export default {
  components: {
    navigator,
    sideBar,
    bkFilter
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  computed:{
    spinShow:function(){
      return this.$store.state.spinShow
    },
  },
  beforeCreate:function(){

  },
  mounted: function (){
    sessionStorage.shouFirst = 1 //第一次进首页
    if(this.$util.getUrlKey('istv') == 1){
      window.btnclick = this.btnclick
      this.isTV = true
      this.$store.commit("updateIsTv", 1);
      this.$store.commit("updateNavText", "弘扬民族文化，学习习近平讲话，建设美好社区");

       if (
         window.location.host.indexOf("localhost") > -1 ||
         window.location.host.indexOf("ceshi.shequyun") > -1 ||
         window.location.host.indexOf("py.shequyun") > -1
       ) {
         this.$router.push({path: '/'});
       }else{
          this.$router.push({path: '/NewLogin'});
       }
      document.getElementsByTagName('body')[0].style.zoom=0.5
    }else if (this.$util.getUrlKey('project') == 'congtai') {
      document.getElementsByTagName('body')[0].style.zoom=0.5
    } else {
      if(this.$util.getUrlKey('project') == 'py') {
        document.getElementsByTagName('body')[0].style.zoom=2
      }
      this.$store.commit("updateIsTv", 0);
      this.$store.commit("updateNavText", "");
    }
  },
  methods:{
    btnclick:function(param){
      //0左面翻页，1右面翻页
      let index = this.router_index
      if(param == 1){
        index++;
        if(index == this.router_arr.length) index=0;
      }else if(param == 0){
        index--;
        if(index<0) index=this.router_arr.length-1;
      }else{
        sessionStorage.shouFirst = 1
        index=0;
      }
      this.router_index = index
      this.$router.push({path: this.router_arr[index].path,params:this.router_arr[index].param});
    },
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    }
  },
  data(){
    return {

      isRouterAlive:true,
      isTV:false,
      transitionName:'',
      router_arr:[{
        path:'/shijianbanli',
        param:{}
      },{
        path:'/Shouye',
        param:{}
      },
      {
        path:'/weizhibu',
        param:{}
      },
      {
        path:'/weishequ',
        param:{}
      },{
        path:'/shequgonggao',
        param:{}
      },{
        path:'/shequhuodong',
        param:{}
      },{
        path:'/shijianbanli',
        param:{}
      }],
      router_index:0
    }
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(to.meta.index > from.meta.index){
        //设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  }
};
</script>

<style lang="less">
.amap-layer[style*="z-index: 9999"]{
  opacity: 0 !important
}
html,
body,
.app-wrapper {
  min-height: 100% !important;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Source Han Sans CN";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f1f1f1;
  overflow-y: scroll;
  cursor: default;
}

/* 重置iview样式  header*/
#app-header.app-header {
  height: 60px !important;
  line-height: inherit;
  background-color: #ff7743;
}
/* 重置iview side 样式 */
#app-sider {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  background: #f1f1f1;
}
/* 筛选组件 */
#app-filter {
  width: 260px !important;
  min-width: 260px !important;
  max-width: 260px !important;
  background: #f1f1f1;
}
#app-content {
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
  background: #f1f1f1;
}
#app-content::-webkit-scrollbar {display:none}
@media only screen and  (max-width: 600px){
  #app{
    overflow-y: visible
  }
  #app-content {
    overflow: hidden;
    background: #f1f1f1;
  }
}
#app::-webkit-scrollbar{
  width:0px;
}
.box {
  display: flex;
}
.box_f1 {
  flex: 1;
}
.ac {
  align-items: center;
}
@yellow: #ffb636 !important;
@primarycolor: #ff7b44 !important;
html,
body,
#app {
  height: 100%;
  //overflow: auto;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f1f1f1;
}
.side {
  width: 150px;
  flex: 0;
}
.routerView {
  margin-left: 151px;
  padding-top: 60px;
  height: 100%;
}
.w92{
  width: 92%;
  margin: 0 auto;
}
.box {
  display: flex;
}
.box_between{
  justify-content:space-between
}
.box_around{
  justify-content:space-around
}
.box_center{
  justify-content:center
}
.box_f1 {
  flex: 1;
}
.box_f2{
  flex: 2;
}
.box_v {
  display: flex;
  flex-direction: column;
}
.hide {
  display: none;
}
.ac {
  align-items: center;
}
.color {
  color: #ff7b44;
}
.bc-color {
  background: #ff7b44;
}
button {
  cursor: pointer;
}
.btn-submit {
  background-color: #32b16c;
}
.btn-yellow {
  background-color: @yellow;
  border-color: @yellow;
}
.btn-size {
  width: 90px;
}
.delete-text {
  color: #67799f !important;
}
.red {
  color: #d22b2b;
}
.slh {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/*页面过渡动画1*/
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms ease;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.pointer{
  cursor: pointer;
}


</style>

<style type="text/css">
/**iconfont 多色图标使用 */
.icon {
   width: 1em; height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
}
</style>
